/* Noventis Lab — interacciones */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.nx-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function hero(scope) {
    (scope || document).querySelectorAll('[data-nx-hero]').forEach(function (h) {
      var glow = h.querySelector('[data-nx-glow]');
      if (!glow || reduce || h.dataset.ready) return;
      h.dataset.ready = '1';
      h.addEventListener('pointermove', function (e) {
        var r = h.getBoundingClientRect();
        glow.style.setProperty('--x', ((e.clientX - r.left) / r.width) * 100 + '%');
        glow.style.setProperty('--y', ((e.clientY - r.top) / r.height) * 100 + '%');
      });
    });
  }

  var manifestos = [];
  function manifesto(scope) {
    (scope || document).querySelectorAll('[data-nx-manifesto]').forEach(function (m) {
      if (m.dataset.ready) return;
      m.dataset.ready = '1';
      manifestos.push({ el: m, words: Array.prototype.slice.call(m.querySelectorAll('.nx-w')) });
    });
    onScroll();
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var vh = window.innerHeight;
      manifestos.forEach(function (o) {
        var r = o.el.getBoundingClientRect();
        var p = (vh * 0.85 - r.top) / (r.height * 0.9);
        p = Math.max(0, Math.min(1, p));
        var n = reduce ? o.words.length : Math.round(p * o.words.length);
        o.words.forEach(function (w, i) { w.classList.toggle('is-on', i < n); });
      });
      document.querySelectorAll('[data-nx-reason]').forEach(function (r) {
        var b = r.getBoundingClientRect();
        if (b.top < vh * 0.55 && b.bottom > vh * 0.45) {
          var sec = r.closest('.nx-reasons');
          var c = sec && sec.querySelector('[data-nx-reason-current]');
          if (c) c.textContent = r.getAttribute('data-nx-reason');
          sec.querySelectorAll('.nx-reason').forEach(function (x) { x.classList.toggle('is-current', x === r); });
        }
      });
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  function transparency(scope) {
    (scope || document).querySelectorAll('[data-nx-transp]').forEach(function (t) {
      if (t.dataset.ready) return;
      t.dataset.ready = '1';
      var btns = t.querySelectorAll('[data-nx-mode]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var nov = b.getAttribute('data-nx-mode') === 'noventis';
          btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          t.classList.toggle('is-noventis', nov);
          t.classList.remove('is-scanning'); void t.offsetWidth; t.classList.add('is-scanning');
        });
      });
      /* Se activa solo la primera vez que entra en pantalla */
      if ('IntersectionObserver' in window && !reduce) {
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) {
            io.disconnect();
            setTimeout(function () { if (!t.classList.contains('is-noventis')) btns[1] && btns[1].click(); }, 1400);
          }
        }, { threshold: 0.6 });
        io.observe(t);
      }
    });
  }

  function lab(scope) {
    (scope || document).querySelectorAll('[data-nx-lab]').forEach(function (l) {
      if (l.dataset.ready) return;
      l.dataset.ready = '1';
      var tabs = l.querySelectorAll('[role="tab"]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) {
            var on = x === t;
            x.setAttribute('aria-selected', on ? 'true' : 'false');
            var p = document.getElementById(x.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
        });
      });
    });
  }

  function init(scope) { reveal(scope); hero(scope); manifesto(scope); transparency(scope); lab(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
